
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-08-12-llamaindex-ts",
      function () {
        return require("private-next-pages/blogs/2023-08-12-llamaindex-ts/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-08-12-llamaindex-ts"])
      });
    }
  